<h3>
  {{ label }}
</h3>
<markant-platform-ui-country-select
  data-cy="select-country"
  [label]="label"
  [outlined]="true"
  [placeholder]="'common.search' | transloco"
  (valueChanged)="selectCountry($event)"
>
</markant-platform-ui-country-select>
<div class="checkbox-wrapper">
  @for (option of visibleOptions | sort; track $index) {
    <markant-checkbox
      class="checkbox"
      [name]="option.label"
      [checked]="selectedOptions | arrayIncludes: option.key"
      (checkedChange)="toggleOption(option)"
    >
      {{ option.isTranslationKey ? (option.label | transloco) : option.label }}
    </markant-checkbox>
  }
</div>
